import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg height="512" viewBox="0 0 32 32" width="512" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6 12a4 4 0 104 4 4 4 0 00-4-4zm0 6a2 2 0 112-2 2 2 0 01-2 2zm10-6a4 4 0 104 4 4 4 0 00-4-4zm0 6a2 2 0 112-2 2 2 0 01-2 2zm10-6a4 4 0 104 4 4 4 0 00-4-4zm0 6a2 2 0 112-2 2 2 0 01-2 2z" data-name="Layer 51" /></svg>);